// User Auth Actions
export const LOGOUT = "LOGOUT";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const VERIFY_SUCCESS = "VERIFY_SUCCESS";
export const VERIFY_ERROR = "VERIFY_ERROR";

export const LOGIN_SAGA = "LOGIN_SAGA";
export const VERIFY_SAGA = "VERIFY_SAGA";

// User Profile Actions
export const SET_PROFILE_DATA = "SET_PROFILE_DATA";
export const SET_EXPIRATION_DATA = "SET_EXPIRATION_DATA";
export const GET_PROFILE_DATA_SAGA = "GET_PROFILE_DATA_SAGA";
export const EDIT_PROFLIE_DATA_SAGA = "EDIT_PROFLIE_DATA_SAGA";
export const END_LOADING = "END_LOADING";

// Furniture pallete
export const GET_PALLETES_SAGA = "GET_PALLETES_SAGA";
export const GET_MATERIALS_SAGA = "GET_MATERIALS_SAGA";
export const MATERIALS_FETCHED = "MATERIALS_FETCHED";
export const PALLETES_FETCHED = "PALLETES_FETCHED";
export const ADD_PALLETE_SAGA = "ADD_PALLETE_SAGA";
export const DELETE_PALLETE_SAGA = "DELETE_PALLETE_SAGA";
export const EDIT_PALLETE_SAGA = "EDIT_PALLETE_SAGA";
export const PALLETE_ADDED = "PALLETE_ADDED";
export const PALLETE_DELETED = "PALLETE_DELETED";
export const PALLETE_EDITED = "PALLETE_EDITED";

// Create Product
export const ADD_KEYVALUE = "ADD_KEYVALUE";

export const ADD_PRODUCT_KEYVALUE = "ADD_PRODUCT_KEYVALUE";
export const DELETE_PRODUCT_KEYVALUE = "DELETE_PRODUCT_KEYVALUE";

export const ADD_PRODUCT_IMAGE = "ADD_PRODUCT_IMAGE";
export const DELELTE_PRODUCT_IMAGE = "DELELTE_PRODUCT_IMAGE";

export const ADD_PRODUCT_SELLER = "ADD_PRODUCT_SELLER";
export const DELETE_PRODUCT_SELLER = "DELETE_PRODUCT_SELLER";

export const ADD_PRODUCT_FEATURE = "ADD_PRODUCT_FEATURE";
export const DELETE_PRODUCT_FEATURE = "DELETE_PRODUCT_FEATURE";

export const ADD_SELLER_FEATURE = "ADD_SELLER_FEATURE";
export const DELETE_SELLER_FEATURE = "DELETE_SELLER_FEATURE";

export const ADD_TAG = "ADD_TAG";
export const DELETE_TAG = "DELETE_TAG";

export const GET_CATEGORY_FEATURES_SAGA = "GET_CATEGORY_FEATURES_SAGA";
export const GET_BRANDS_SAGA = "GET_BRANDS_SAGA";
export const GET_CATEGORIES_SAGA = "GET_CATEGORIES_SAGA";
export const GET_SUBCATEGORIES_SAGA = "GET_SUBCATEGORIES_SAGA";
export const GET_SECOND_SUBCATEGORIES_SAGA = "GET_SECOND_SUBCATEGORIES_SAGA";

export const CREATE_PRODUCT_SAGA = "CREATE_PRODUCT_SAGA";
export const END_CREATION_LOADING = "END_CREATION_LOADING";
